import { Container, Image, Row, Col, Stack } from 'react-bootstrap';
import styled from 'styled-components';
import React from 'react';

const StyledContainer = styled(Container)`
    &&& {
        background: white;
        z-index: 1;
    }
`;

const StyledStack = styled(Stack)`
    &&& {
        color: rgba(0, 0, 0, 0.5);
        font-weight: 500;
        font-family: Montserrat, sans-serif;
        text-align: center;
    }

    @media (max-width: 460px) {
        padding: 0 15px;
    }
`;

const StyledImage = styled(Image)`
    &&& {
        width: 175px;
    }

    @media (min-width: 300px) and (max-width: 500px) {
        width: 50px;
    }
`;

const StyledImage2 = styled(Image)`
    &&& {
        margin-top: 8px;
    }

    @media (min-width: 300px) and (max-width: 500px) {
        width: 100%;
        margin-top: 0;
    }
`;

const ImageContainer = styled.div`
    display: flex;
    // justify-content: center;
    // align-items: center;
    padding: 40px;

    @media (min-width: 300px) and (max-width: 500px) {
        position: static;
        top: 0;
        padding: 20px;
    }
`;

const ICParagraphText = styled.p`
    color: #A7A9AC;
    font-weight: 500;
    font-size: 12px;
    font-family: Montserrat, sans-serif;
    text-align: center;
`;

const ContactLink = styled.a`
    text-decoration: none;
    color: rgba(0, 0, 0, 0.5);
`;

const EmailLink = styled.a`
    text-decoration: none;
    color: rgba(0, 0, 0, 0.5);
`;

const StyledDivision = styled.div`
    padding: 20px 50px 20px 20px;
    margin: 0% 15%;
    border-bottom: 2px solid gray;
`;

export default function Footer({paramsData}) {
    const sustainabilityLogo = paramsData.find((item) => item.paramName === 'BPI_SUSTAINABILITY_LOGO');

    return (
        <StyledContainer id="contact-us" fluid>
            <Row className="d-flex justify-content-center align-items-center">
                <Col xs="auto" className="p-0">
                    <ImageContainer>
                        <StyledImage src={require('../../assets/bpims-logo.png')} fluid />
                    </ImageContainer>
                </Col>
                <Col xs="auto" className="p-0">
                    <ImageContainer>
                        <StyledImage2 src={require('../../assets/home-credit-logo-1.png')} fluid />
                    </ImageContainer>
                </Col>
            </Row>
            <Row>
                <Col lg={12} className="justify-content-center pt-3">
                    <StyledStack className="text-center mb-5">
                        <p className="m-0 p-0">Powered by BPI/MS Insurance Corporation, a joint venture between the</p>
                        <p className="m-0 p-0 mb-3">
                            Bank of the Philippine Islands and Mitsui Sumitomo Insurance Company, Limited.
                        </p>
                        <p className="m-0 p-0" style={{ fontWeight: 'bold' }}>
                            Policy terms and conditions apply.
                        </p>
                        <p className="m-0 p-0 mb-3">
                            BPI/MS Insurance Corporation's products are non-life insurance products and are not deposit products of Bank of the Philippine Islands. <br/> 
                            These products are not covered by the Philippine Deposit Insurance Corporation.
                        </p>
                        <p className="m-0 p-0 mb-3">
                            11th, 14th, 16th & 18th Floors, 6811 BPI AIA Makati 
                            Ayala Avenue Salcedo Village, <br/> Bel-Air 1209 City of Makati NCR, Fourth District Philippines
                        </p>
                        <p className="m-0 p-0">
                            For concerns, you may call BPI MS at <ContactLink href="tel:+63288409000">(+632) 8840 9000</ContactLink> or send an e-mail to <EmailLink href="mailto:help@bpims.com">helpline@bpims.com</EmailLink>,
                        </p>
                        <p className="m-0 p-0">&nbsp;Monday to Friday, 8AM to 5PM except holidays.</p>
                        <br />
                        <p className="m-0 p-0" style={{ fontWeight: 'bold' }}>
                            Seeking assistance for emergency home repairs? <br />
                            Call BPI MS Home Assistance at <ContactLink href="tel:+63284594748">(+632) 8459 4748</ContactLink>
                        </p>
                        <br />
                        <p className="m-0 p-0">
                            BPI/MS Insurance Corporation is regulated by the Insurance Commission (IC).
                        </p>
                        <p className="m-0 p-0">For more details, visit https://www.insurance.gov.ph.</p>
                        <br />
                        <ICParagraphText className="m-0 p-0">IC Public Assistance Office contact details:</ICParagraphText>
                        <ICParagraphText className="m-0 p-0">Landline: (02) 8523-8461 loc. 103/127</ICParagraphText>
                        <ICParagraphText className="m-0 p-0">SMS: 09171160007 or 09999930637</ICParagraphText>
                        <ICParagraphText className="m-0 p-0">E-mail: publicassistance@insurance.gov.ph</ICParagraphText>
                        <ICParagraphText className="m-0 p-0">Offices: https://www.insurance.gov.ph/contact-us/</ICParagraphText>
                        {/* <StyledHr /> */}

                        {sustainabilityLogo && (
                            <>
                                <StyledDivision />
                                <StyledImage
                                    src={sustainabilityLogo.paramValueV}
                                    alt="Sustainability logo"
                                    fluid
                                    className="mx-auto py-4"
                                    width="200px"
                                />
                                <p>BPI MS’ Digital Evolution Insures the Future </p>
                            </>
                        )}
                    </StyledStack>
                </Col>
            </Row>
        </StyledContainer>
    );
}
